import { useEffect } from "react";
import useCurrentUser from "./useCurrentUser";
import TagManager from "react-gtm-module";
import config from "../config";

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

type userLoginType = {
  event: String;
  name: String;
  memberNumber: String;
  sub: String;
};

type tagManagerArgsType = {
  gtmId: string;
  auth?: string;
  preview?: string;
};
// use this function to push additional events to the dataLayer
export const gtmEvent = (obj: userLoginType) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(obj);
};

const useGtm = () => {
  const { initialized, currentUser } = useCurrentUser();

  // use react-gtm-module to instantiate GTM
  useEffect(() => {
    const tagManagerArgs: tagManagerArgsType = {
      gtmId: config.gtmId,
      auth: config.gtmAuth,
      preview: config.gtmPreview,
    };

    config.gtmId && TagManager.initialize(tagManagerArgs);
  }, [config.gtmId]);

  // push user to dataLayer on initial load
  useEffect(() => {
    if (initialized && currentUser != null) {
      const userLoginArgs: userLoginType = {
        event: "userLogin",
        name: `${currentUser.firstName} ${currentUser.lastName}`,
        memberNumber: currentUser.memberNumber!,
        sub: currentUser.sub!,
      };
      gtmEvent(userLoginArgs);
    }
  }, [initialized, currentUser]);
};

export default useGtm;
